import { __assign, __extends } from "tslib";
import * as React from 'react';
import { Popper, Target, Arrow, Manager } from 'react-popper';
import * as Portal from 'react-portal-minimal';
import { namespacedClassnames } from './namespace-classes';
export var TOOLTIP_CLOSE_TRANSITION_DELAY = 200;
export var TOOLTIP_INITIALIZE_TIME = 50;
var PopperEngine = /** @class */ (function (_super) {
    __extends(PopperEngine, _super);
    function PopperEngine() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            status: 'dormant',
        };
        _this.statusLock = false;
        _this.customApplyStylesModifier = {
            enabled: true,
            order: 860,
            fn: function (data) {
                var _a, _b;
                var _c = _this, props = _c.props, state = _c.state;
                var actualPlacement = data.placement;
                var isReady = state.status === 'ready';
                var isVisible = props.show;
                var isHiding = state.status === 'trigger-hide';
                var left = Math.floor(data.offsets.popper.left);
                var top = Math.floor(data.offsets.popper.top);
                var isTop = actualPlacement === 'top';
                var isBottom = actualPlacement === 'bottom';
                var notReadyOrHidden = !isReady || !isVisible;
                var newTop = isTop && notReadyOrHidden ? top - 10 :
                    isBottom && notReadyOrHidden ? top + 10 :
                        top;
                var isLeft = actualPlacement === 'left';
                var isRight = actualPlacement === 'right';
                var newLeft = isLeft && notReadyOrHidden ? left - 10 :
                    isRight && notReadyOrHidden ? left + 10 :
                        left;
                var offsettedLeft = newLeft + (((_a = props.offset) === null || _a === void 0 ? void 0 : _a.x) || 0);
                var offsettedTop = newTop + (((_b = props.offset) === null || _b === void 0 ? void 0 : _b.y) || 0);
                var transform = "translate3d(".concat(offsettedLeft, "px, ").concat(offsettedTop, "px, 0px)");
                var opacity = isReady && isVisible ? 1 : 0;
                var transition = isReady || isHiding ? 'all .2s ease-in-out' : undefined;
                var popper = __assign(__assign({}, data.popper), { left: offsettedLeft, top: offsettedTop });
                var offsets = __assign(__assign({}, data.offsets), { popper: popper });
                var styles = __assign(__assign({}, data.styles), { opacity: opacity, transform: transform, transition: transition });
                if (_this.statusLock) {
                    _this.statusLock = false;
                    var delayTime = state.status === 'trigger-show'
                        ? props.initializeDelayTime || TOOLTIP_INITIALIZE_TIME
                        : state.status === 'trigger-hide'
                            ? TOOLTIP_CLOSE_TRANSITION_DELAY
                            : 0;
                    setTimeout(function () {
                        _this.setState(function (prevState) {
                            if (prevState.status === 'trigger-show') {
                                return { status: 'ready' };
                            }
                            else if (prevState.status === 'trigger-hide') {
                                return { status: 'dormant' };
                            }
                            else {
                                return prevState;
                            }
                        });
                    }, delayTime);
                }
                return __assign(__assign({}, data), { offsets: offsets, styles: styles, popper: popper });
            }
        };
        _this.triggerShow = function () {
            if (!_this.statusLock) {
                _this.statusLock = true;
                _this.setState({ status: 'trigger-show' });
            }
        };
        _this.triggerHide = function () {
            if (!_this.statusLock) {
                _this.statusLock = true;
                _this.setState({ status: 'trigger-hide' });
            }
        };
        return _this;
    }
    PopperEngine.prototype.componentWillMount = function () {
        if (this.props.show === true) {
            this.triggerShow();
        }
    };
    PopperEngine.prototype.componentWillReceiveProps = function (nextProps) {
        var currShow = this.props.show;
        var nextShow = nextProps.show;
        if (!currShow && nextShow) {
            this.triggerShow();
        }
        else if (currShow && !nextShow) {
            this.triggerHide();
        }
    };
    PopperEngine.prototype.render = function () {
        var _a = this, props = _a.props, state = _a.state;
        var classNames = "popper ".concat(props.className || '');
        var portalClassName = namespacedClassnames('popper-portal-dest');
        var popperTargetClassName = "popper-target ".concat(props.popperTargetClassName || '');
        var defaultBodyStyle = {
            pointerEvents: props.show ? 'initial' : 'none'
        };
        var modifiers = {
            customApplyStylesModifier: this.customApplyStylesModifier,
            preventOverflow: { boundariesElement: props.relativeToBody ? 'viewport' : 'scrollParent' }
        };
        var placement = props.direction || 'top';
        var popperElem = (React.createElement(Popper, { eventsEnabled: state.status !== 'dormant', placement: placement, className: classNames, style: defaultBodyStyle, modifiers: modifiers },
            props.body,
            React.createElement(Arrow, { className: 'popper-arrow' })));
        var renderedPopper = this.props.relativeToBody ? (React.createElement(Portal, { className: portalClassName }, popperElem)) : popperElem;
        return (React.createElement(Manager, null,
            React.createElement(Target, { className: popperTargetClassName }, props.children),
            this.state.status !== 'dormant' ? renderedPopper : null));
    };
    return PopperEngine;
}(React.PureComponent));
export { PopperEngine };
//# sourceMappingURL=popper-engine.js.map